import React from "react";

export default function TotalBalance({ lifetimeBalance, lifetimeBalanceUSD }) {
  return (
    <div className="totalPaid">
      TOTAL {lifetimeBalance} ETH <span>= {lifetimeBalanceUSD}</span>
    </div>
  );
}
